import { ColumnProps, GridView, SimpleView, Table, Widget, Row, FormInput, Col, FormResetButton, Form, Button } from '@digital/ui';
import React, { useState, useEffect, useMemo } from 'react';
import { getAllProjetoPacote, RelatorioProjetoPacote, postExportarRelatorio, ReportProjetoPacoteResult } from '@app/api/relatorioProjetoPacote'
import { Collapse, Icon } from 'antd';
import { compareText, compareCurrencyDecimal } from '@app/helpers/comparators';
const { Panel } = Collapse;

const larguraColuna = {
    numeroLinha: 5,
    totvs: 5,
    tap: 100,
    codigoProjeto: 10,
    nomeProjeto: 400,
    nomeDiretoria: 150,
    nomeArea: 150,
    nomeDepartamento: 150,
    grupo: 150,
    subGrupo: 150,
    naoPrevisto: 150,
    codigoPacote: 150,
    nomePacote: 400,
    orcado: 150,
}


const RelatorioPacote = () => {

    const [result, setResult] = useState([] as RelatorioProjetoPacote[]);
    const [resultTotais, setTotais] = useState({} as ReportProjetoPacoteResult);

    useEffect(() => {
        GetAll();
    }, []);

    const GetAll = () => {
        getAllProjetoPacote().then((data) => {
            if (data) {
                setResult(data.listReportProjetoPacote);
                setTotais(data);
            }
        });
    }


    const larguraTabela = () => {
        let valorTotal = 0;
        for (var prop in larguraColuna) {
            valorTotal += larguraColuna[prop];
        }
        valorTotal += larguraColuna.orcado * 31;
        return valorTotal;
    }

    const getNameColluns = (ultimoMesExecutado: number, mes: number): string => {
        if (ultimoMesExecutado >= mes)
            return 'EXECUTADO'
        return 'FORECAST'
    }

    const colunas = useMemo(() => {
        let colluns: ColumnProps<RelatorioProjetoPacote>[] = new Array();
        colluns.push(
            {
                title: 'N',
                dataIndex: 'numeroLinha',
                width: larguraColuna.numeroLinha,
            });


        colluns.push(
            {
                title: 'totvs',
                dataIndex: 'totv',
                width: larguraColuna.totvs,
                sorter: (a: { totv: string; }, b: { totv: string; }) => compareText(a.totv, b.totv),
            });

        colluns.push(
            {
                title: 'tab',
                dataIndex: 'tap',
                width: larguraColuna.tap,
                sorter: (a: { tap: string; }, b: { tap: string; }) => compareText(a.tap, b.tap),
            });


        colluns.push(
            {
                title: 'Cód. Projeto',
                dataIndex: 'codigoProjeto',
                width: larguraColuna.codigoProjeto,
                sorter: (a: { codigoProjeto: string; }, b: { codigoProjeto: string; }) => compareText(a.codigoProjeto, b.codigoProjeto),
            });


        colluns.push(
            {
                title: 'Nome do Projeto',
                dataIndex: 'nomeProjeto',
                width: larguraColuna.nomeProjeto,
                sorter: (a: { nomeProjeto: string; }, b: { nomeProjeto: string; }) => compareText(a.nomeProjeto, b.nomeProjeto),
            });


        colluns.push(
            {
                title: 'Diretoria',
                dataIndex: 'nomeDiretoria',
                width: larguraColuna.nomeDiretoria,
                sorter: (a: { nomeDiretoria: string; }, b: { nomeDiretoria: string; }) => compareText(a.nomeDiretoria, b.nomeDiretoria),
            });

        colluns.push(
            {
                title: 'Área',
                dataIndex: 'nomeArea',
                width: larguraColuna.nomeArea,
                sorter: (a: { nomeArea: string; }, b: { nomeArea: string; }) => compareText(a.nomeArea, b.nomeArea),
            });

        colluns.push(
            {
                title: 'DPT',
                dataIndex: 'nomeDepartamento',
                width: larguraColuna.nomeDepartamento,
                sorter: (a: { nomeDepartamento: string; }, b: { nomeDepartamento: string; }) => compareText(a.nomeDepartamento, b.nomeDepartamento),
            });

        colluns.push(
            {
                title: 'Grupo',
                dataIndex: 'grupo',
                width: larguraColuna.grupo,
                sorter: (a: { grupo: string; }, b: { grupo: string; }) => compareText(a.grupo, b.grupo),
            });


        colluns.push(
            {
                title: 'Sub Grupo',
                dataIndex: 'subGrupo',
                width: larguraColuna.subGrupo,
                sorter: (a: { subGrupo: string; }, b: { subGrupo: string; }) => compareText(a.subGrupo, b.subGrupo),
            });

        colluns.push(
            {
                title: 'Não Previsto',
                dataIndex: 'naoPrevisto',
                width: larguraColuna.naoPrevisto,
                sorter: (a: { naoPrevisto: string; }, b: { naoPrevisto: string; }) => compareText(a.naoPrevisto, b.naoPrevisto),
            });

        colluns.push(
            {
                title: 'Cód. Pacote',
                dataIndex: 'codigoPacote',
                width: larguraColuna.codigoPacote,
                sorter: (a: { codigoPacote: string; }, b: { codigoPacote: string; }) => compareText(a.codigoPacote, b.codigoPacote),
            });

        colluns.push(
            {
                title: 'Nome Pacote',
                dataIndex: 'nomePacote',
                width: larguraColuna.nomePacote,
                sorter: (a: { nomePacote: string; }, b: { nomePacote: string; }) => compareText(a.nomePacote, b.nomePacote),
            });

        colluns.push(
            {
                title: 'ORÇADO',
                children: [
                    {
                        title: 'A',
                        children: [
                            {
                                title: `${resultTotais.orcadoTotal}`,
                                dataIndex: 'orcadoFormatado',
                                sorter: (a: { orcado: number; }, b: { orcado: number; }) => compareCurrencyDecimal(a.orcado, b.orcado),
                                width: larguraColuna.orcado,
                            }
                        ]
                    },
                ],
            });

        colluns.push(
            {
                title: 'CONTRATADO',
                children: [
                    {
                        title: 'B',
                        children: [
                            {
                                title: `${resultTotais.contratadoTotal}`,
                                dataIndex: 'contratadoFormatado',
                                sorter: (a: { contratado: number; }, b: { contratado: number; }) => compareCurrencyDecimal(a.contratado, b.contratado),
                                width: larguraColuna.orcado,
                            }
                        ]
                    },
                ],

            });

        colluns.push(
            {
                title: 'EXECUTADO',
                children: [
                    {
                        title: 'C',
                        children: [
                            {
                                title: `${resultTotais.executadoTotal}`,
                                dataIndex: 'executadoFormatado',
                                sorter: (a: { executado: number; }, b: { executado: number; }) => compareCurrencyDecimal(a.executado, b.executado),
                                width: larguraColuna.orcado,
                            }
                        ]
                    },
                ],
            });

        colluns.push(
            {
                title: 'REQUISITADO',
                children: [
                    {
                        title: 'D',
                        children: [
                            {
                                title: `${resultTotais.requisitadoTotal}`,
                                dataIndex: 'requisitadoFormatado',
                                sorter: (a: { requisitado: number; }, b: { requisitado: number; }) => compareCurrencyDecimal(a.requisitado, b.requisitado),
                                width: larguraColuna.orcado,
                            }
                        ]
                    },
                ],
            });

        colluns.push(
            {
                title: 'COMPROMISSADO',
                children: [
                    {
                        title: 'E = B - C + D',
                        children: [
                            {
                                title: `${resultTotais.compromissadoTotal}`,
                                dataIndex: 'compromissadoFormatado',
                                sorter: (a: { compromissado: number; }, b: { compromissado: number; }) => compareCurrencyDecimal(a.compromissado, b.compromissado),
                                width: larguraColuna.orcado,
                            }
                        ]
                    },
                ],
            });

        colluns.push(
            {
                title: 'A CONTRATAR',
                children: [
                    {
                        title: 'F',
                        children: [
                            {
                                title: `${resultTotais.aContratarTotal}`,
                                dataIndex: 'aContratarFormatado',
                                sorter: (a: { aContratar: number; }, b: { aContratar: number; }) => compareCurrencyDecimal(a.aContratar, b.aContratar),
                                width: larguraColuna.orcado,
                            }
                        ]
                    },
                ],
            });

        colluns.push(
            {
                title: 'FORECAST',
                children: [
                    {
                        title: 'G = B + D + F',
                        children: [
                            {
                                title: `${resultTotais.forecastTotal}`,
                                dataIndex: 'forecastFormatado',
                                sorter: (a: { forecast: number; }, b: { forecast: number; }) => compareCurrencyDecimal(a.forecast, b.forecast),
                                width: larguraColuna.orcado,
                            }
                        ]
                    },
                ],
            });


        colluns.push(
            {
                title: 'VARIAÇÃO',
                children: [
                    {
                        title: 'H = A - G',
                        children: [
                            {
                                title: `${resultTotais.variacaoTotal}`,
                                dataIndex: 'variacaoFormatado',
                                sorter: (a: { variacao: number; }, b: { variacao: number; }) => compareCurrencyDecimal(a.variacao, b.variacao),
                                width: larguraColuna.orcado,
                            }
                        ]
                    },
                ],
            });


        colluns.push(
            {
                title: 'ORÇADO',
                children: [
                    {
                        title: 'Janeiro',
                        children: [
                            {
                                title: `${resultTotais.orcadoJaneiroTotal}`,
                                dataIndex: 'orcadoJaneiroFormatado',
                                sorter: (a: { orcadoJaneiro: number; }, b: { orcadoJaneiro: number; }) => compareCurrencyDecimal(a.orcadoJaneiro, b.orcadoJaneiro),
                                width: larguraColuna.orcado,
                            },
                        ],
                    },
                    {
                        title: 'FEVEREIRO',
                        children: [
                            {
                                title: `${resultTotais.orcadoFevereiroTotal}`,
                                dataIndex: 'orcadoFevereiroFormatado',
                                width: larguraColuna.orcado,
                                sorter: (a: { orcadoFevereiro: number; }, b: { orcadoFevereiro: number; }) => compareCurrencyDecimal(a.orcadoFevereiro, b.orcadoFevereiro),
                            },
                        ],
                    },
                    {
                        title: 'MARÇO',
                        children: [
                            {
                                title: `${resultTotais.orcadoMarcoTotal}`,
                                dataIndex: 'orcadoMarcoFormatado',
                                width: larguraColuna.orcado,
                                sorter: (a: { orcadoMarco: number; }, b: { orcadoMarco: number; }) => compareCurrencyDecimal(a.orcadoMarco, b.orcadoMarco),
                            },
                        ],
                    },
                    {
                        title: 'ABRIL',
                        children: [
                            {
                                title: `${resultTotais.orcadoAbrilTotal}`,
                                dataIndex: 'orcadoAbrilFormatado',
                                width: larguraColuna.orcado,
                                sorter: (a: { orcadoAbril: number; }, b: { orcadoAbril: number; }) => compareCurrencyDecimal(a.orcadoAbril, b.orcadoAbril),
                            },
                        ],
                    },
                    {
                        title: 'MAIO',
                        children: [
                            {
                                title: `${resultTotais.orcadoMaioTotal}`,
                                dataIndex: 'orcadoMaioFormatado',
                                width: larguraColuna.orcado,
                                sorter: (a: { orcadoMaio: number; }, b: { orcadoMaio: number; }) => compareCurrencyDecimal(a.orcadoMaio, b.orcadoMaio),
                            },
                        ],
                    },
                    {
                        title: 'JUNHO',
                        children: [
                            {
                                title: `${resultTotais.orcadoJunhoTotal}`,
                                dataIndex: 'orcadoJunhoFormatado',
                                width: larguraColuna.orcado,
                                sorter: (a: { orcadoJunho: number; }, b: { orcadoJunho: number; }) => compareCurrencyDecimal(a.orcadoJunho, b.orcadoJunho),
                            },
                        ],
                    },
                    {
                        title: 'JULHO',
                        children: [
                            {
                                title: `${resultTotais.orcadoJulhoTotal}`,
                                dataIndex: 'orcadoJulhoFormatado',
                                width: larguraColuna.orcado,
                                sorter: (a: { orcadoJulho: number; }, b: { orcadoJulho: number; }) => compareCurrencyDecimal(a.orcadoJulho, b.orcadoJulho),
                            },
                        ],
                    },
                    {
                        title: 'AGOSTO',
                        children: [
                            {
                                title: `${resultTotais.orcadoAgostoTotal}`,
                                dataIndex: 'orcadoAgostoFormatado',
                                width: larguraColuna.orcado,
                                sorter: (a: { orcadoAgosto: number; }, b: { orcadoAgosto: number; }) => compareCurrencyDecimal(a.orcadoAgosto, b.orcadoAgosto),
                            },
                        ],
                    },
                    {
                        title: 'SETEMBRO',
                        children: [
                            {
                                title: `${resultTotais.orcadoSetembroTotal}`,
                                dataIndex: 'orcadoSetembroFormatado',
                                width: larguraColuna.orcado,
                                sorter: (a: { orcadoSetembro: number; }, b: { orcadoSetembro: number; }) => compareCurrencyDecimal(a.orcadoSetembro, b.orcadoSetembro),
                            },
                        ],
                    },
                    {
                        title: 'OUTUBRO',
                        children: [
                            {
                                title: `${resultTotais.orcadoOutubroTotal}`,
                                dataIndex: 'orcadoOutubroFormatado',
                                width: larguraColuna.orcado,
                                sorter: (a: { orcadoOutubro: number; }, b: { orcadoOutubro: number; }) => compareCurrencyDecimal(a.orcadoOutubro, b.orcadoOutubro),
                            },
                        ],
                    },
                    {
                        title: 'NOVEMBRO',
                        children: [
                            {
                                title: `${resultTotais.orcadoNovembroTotal}`,
                                dataIndex: 'orcadoNovembroFormatado',
                                width: larguraColuna.orcado,
                                sorter: (a: { orcadoNovembro: number; }, b: { orcadoNovembro: number; }) => compareCurrencyDecimal(a.orcadoNovembro, b.orcadoNovembro),
                            },
                        ],
                    },
                    {
                        title: 'DEZEMBRO',
                        children: [
                            {
                                title: `${resultTotais.orcadoDezembroTotal}`,
                                dataIndex: 'orcadoDezembroFormatado',
                                width: larguraColuna.orcado,
                                sorter: (a: { orcadoDezembro: number; }, b: { orcadoDezembro: number; }) => compareCurrencyDecimal(a.orcadoDezembro, b.orcadoDezembro),
                            },
                        ],
                    },
                ]
            });

        if (resultTotais) {
            colluns.push(
                {
                    title: (column) => {
                        return <> {getNameColluns(resultTotais.ultimoMesExecutado, 1)} </>
                    },
                    children: [
                        {
                            title: 'Janeiro',
                            children: [
                                {
                                    title: `${resultTotais.executadoForecastJaneiroTotal}`,
                                    dataIndex: 'executadoForecastJaneiroFormatado',
                                    width: larguraColuna.orcado,
                                    sorter: (a: { executadoForecastJaneiro: number; }, b: { executadoForecastJaneiro: number; }) => compareCurrencyDecimal(a.executadoForecastJaneiro, b.executadoForecastJaneiro),
                                }
                            ],
                        }
                    ],
                },
                {
                    title: (column) => {
                        return <> {getNameColluns(resultTotais.ultimoMesExecutado, 2)} </>
                    },
                    children: [
                        {
                            title: 'FEVEREIRO',
                            children: [
                                {
                                    title: `${resultTotais.executadoForecastFevereiroTotal}`,
                                    dataIndex: 'executadoForecastFevereiroFormatado',
                                    width: larguraColuna.orcado,
                                    sorter: (a: { executadoForecastFevereiro: number; }, b: { executadoForecastFevereiro: number; }) => compareCurrencyDecimal(a.executadoForecastFevereiro, b.executadoForecastFevereiro),
                                }
                            ]
                        }
                    ]
                },
                {
                    title: (column) => {
                        return <> {getNameColluns(resultTotais.ultimoMesExecutado, 3)} </>
                    },
                    children: [
                        {
                            title: 'MARÇO',
                            children: [
                                {
                                    title: `${resultTotais.executadoForecastMarcoTotal}`,
                                    dataIndex: 'executadoForecastMarcoFormatado',
                                    width: larguraColuna.orcado,
                                    sorter: (a: { executadoForecastMarco: number; }, b: { executadoForecastMarco: number; }) => compareCurrencyDecimal(a.executadoForecastMarco, b.executadoForecastMarco),
                                }
                            ]
                        }
                    ]
                },
                {
                    title: (column) => {
                        return <> {getNameColluns(resultTotais.ultimoMesExecutado, 4)} </>
                    },
                    children: [
                        {
                            title: 'ABRIL',
                            children: [
                                {
                                    title: `${resultTotais.executadoForecastAbrilTotal}`,
                                    dataIndex: 'executadoForecastAbrilFormatado',
                                    width: larguraColuna.orcado,
                                    sorter: (a: { executadoForecastAbril: number; }, b: { executadoForecastAbril: number; }) => compareCurrencyDecimal(a.executadoForecastAbril, b.executadoForecastAbril),
                                }
                            ]
                        }
                    ]
                },
                {
                    title: (column) => {
                        return <> {getNameColluns(resultTotais.ultimoMesExecutado, 5)} </>
                    },
                    children: [
                        {
                            title: 'MAIO',
                            children: [
                                {
                                    title: `${resultTotais.executadoForecastMaioTotal}`,
                                    dataIndex: 'executadoForecastMaioFormatado',
                                    width: larguraColuna.orcado,
                                    sorter: (a: { executadoForecastMaio: number; }, b: { executadoForecastMaio: number; }) => compareCurrencyDecimal(a.executadoForecastMaio, b.executadoForecastMaio),

                                }
                            ]

                        }
                    ]
                },
                {
                    title: (column) => {
                        return <> {getNameColluns(resultTotais.ultimoMesExecutado, 6)} </>
                    },
                    children: [
                        {
                            title: 'JUNHO',
                            children: [
                                {
                                    title: `${resultTotais.executadoForecastJunhoTotal}`,
                                    dataIndex: 'executadoForecastJunhoFormatado',
                                    width: larguraColuna.orcado,
                                    sorter: (a: { executadoForecastJunho: number; }, b: { executadoForecastJunho: number; }) => compareCurrencyDecimal(a.executadoForecastJunho, b.executadoForecastJunho),
                                }
                            ]
                        }
                    ]
                },
                {
                    title: (column) => {
                        return <> {getNameColluns(resultTotais.ultimoMesExecutado, 7)} </>
                    },
                    children: [
                        {
                            title: 'JULHO',
                            children: [
                                {
                                    title: `${resultTotais.executadoForecastJulhoTotal}`,
                                    dataIndex: 'executadoForecastJulhoFormatado',
                                    width: larguraColuna.orcado,
                                    sorter: (a: { executadoForecastJulho: number; }, b: { executadoForecastJulho: number; }) => compareCurrencyDecimal(a.executadoForecastJulho, b.executadoForecastJulho),
                                }
                            ]
                        }
                    ]
                },
                {
                    title: (column) => {
                        return <> {getNameColluns(resultTotais.ultimoMesExecutado, 8)} </>
                    },
                    children: [
                        {
                            title: 'AGOSTO',
                            children: [
                                {
                                    title: `${resultTotais.executadoForecastAgostoTotal}`,
                                    dataIndex: 'executadoForecastAgostoFormatado',
                                    width: larguraColuna.orcado,
                                    sorter: (a: { executadoForecastAgosto: number; }, b: { executadoForecastAgosto: number; }) => compareCurrencyDecimal(a.executadoForecastAgosto, b.executadoForecastAgosto),
                                }
                            ]
                        }
                    ]
                },
                {
                    title: (column) => {
                        return <> {getNameColluns(resultTotais.ultimoMesExecutado, 9)} </>
                    },
                    children: [
                        {
                            title: 'SETEMBRO',
                            children: [
                                {
                                    title: `${resultTotais.executadoForecastSetembroTotal}`,
                                    dataIndex: 'executadoForecastSetembroFormatado',
                                    width: larguraColuna.orcado,
                                    sorter: (a: { executadoForecastSetembro: number; }, b: { executadoForecastSetembro: number; }) => compareCurrencyDecimal(a.executadoForecastSetembro, b.executadoForecastSetembro),
                                }
                            ]
                        }
                    ]
                },
                {
                    title: (column) => {
                        return <> {getNameColluns(resultTotais.ultimoMesExecutado, 10)} </>
                    },
                    children: [
                        {
                            title: 'OUTUBRO',
                            children: [
                                {
                                    title: `${resultTotais.executadoForecastOutubroTotal}`,
                                    dataIndex: 'executadoForecastOutubroFormatado',
                                    width: larguraColuna.orcado,
                                    sorter: (a: { executadoForecastOutubro: number; }, b: { executadoForecastOutubro: number; }) => compareCurrencyDecimal(a.executadoForecastOutubro, b.executadoForecastOutubro),
                                }
                            ]
                        }
                    ]
                },
                {
                    title: (column) => {
                        return <> {getNameColluns(resultTotais.ultimoMesExecutado, 11)} </>
                    },
                    children: [
                        {
                            title: 'NOVEMBRO',
                            children: [
                                {
                                    title: `${resultTotais.executadoForecastNovembroTotal}`,
                                    dataIndex: 'executadoForecastNovembroFormatado',
                                    width: larguraColuna.orcado,
                                    sorter: (a: { executadoForecastNovembro: number; }, b: { executadoForecastNovembro: number; }) => compareCurrencyDecimal(a.executadoForecastNovembro, b.executadoForecastNovembro),
                                }
                            ]
                        }
                    ]
                },
                {
                    title: (column) => {
                        return <> {getNameColluns(resultTotais.ultimoMesExecutado, 12)} </>
                    },
                    children: [
                        {
                            title: 'DEZEMBRO',
                            children: [
                                {
                                    title: `${resultTotais.executadoForecastDezembroTotal}`,
                                    dataIndex: 'executadoForecastDezembroFormatado',
                                    width: larguraColuna.orcado,
                                    sorter: (a: { executadoForecastDezembro: number; }, b: { executadoForecastDezembro: number; }) => compareCurrencyDecimal(a.executadoForecastDezembro, b.executadoForecastDezembro),
                                }
                            ]
                        }
                    ]
                },

            );
        }


        return colluns;
    }, [resultTotais]);


    const hasExpostarRelatorio = () => {
        postExportarRelatorio();
    }

    return (
        <>
            <SimpleView >
                <GridView noform>
                    <Collapse bordered={false} defaultActiveKey={['1']} expandIcon={() => <Icon type="arrows-right_4" />}>
                        <Panel key="1" header="Relatório Pacote" style={{ border: 0 }}>
                            <Widget actions={
                                [
                                    <Button
                                        type="primary"
                                        size={'small'}
                                        icon="commons-search"
                                        onClick={() => {
                                            hasExpostarRelatorio();
                                        }}
                                    >
                                        Exporta para Excel
                                    </Button>
                                ]}>
                                <Table
                                    rowKey="id"
                                    id="tableRelatorioProjetoPacote"
                                    columns={colunas}
                                    dataSource={result}
                                    scroll={{ x: larguraTabela() }}
                                    //bordered
                                    pagination={{
                                        pageSize: 15,
                                        onChange: (() => {
                                            document.getElementById("tableRelatorioProjetoPacote").scrollIntoView();
                                        })
                                    }}
                                />
                            </Widget>
                        </Panel>
                    </Collapse>
                </GridView>
            </SimpleView>



        </>);
}


export default RelatorioPacote;

